import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";

const TableHeader = ({ columns, sortColumn, onSort }) => {
  const raiseSort = (path) => {
    if (typeof path === "undefined") return null;

    if (sortColumn.path === path) {
      sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
    } else {
      sortColumn.path = path;
      sortColumn.order = "asc";
    }

    onSort(sortColumn);
  };

  const renderSortIcon = (column) => {
    if (typeof sortColumn.path === "undefined") return null;
    if (column.path !== sortColumn.path) return null;

    if (sortColumn.order === "asc")
      return <FaSortAmountUp className="text-blue-400 ml-2" />;
    return <FaSortAmountDown className="text-blue-400 ml-2" />;
  };

  return (
    <thead className="bg-gray-100">
      <tr>
        {columns.map((column) => (
          <th
            key={column.path || column.key}
            onClick={() => raiseSort(column.path)}
            className="py-3 px-6 text-sm font-normal first:rounded-l-lg last:rounded-r-lg text-gray-400 cursor-pointer"
          >
            <div className="flex justify-between items-center">
              {column.label} {renderSortIcon(column)}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
